var map = {
	"./back.svg": 4075,
	"./banners/badge.svg": 2987,
	"./canceled.svg": 2539,
	"./eye-off.svg": 7269,
	"./eye.svg": 5297,
	"./fav.svg": 9857,
	"./loader-icon.svg": 4571,
	"./mail.svg": 683,
	"./menu/games.svg": 2767,
	"./menu/home.svg": 5563,
	"./menu/profile.svg": 7281,
	"./menu/store.svg": 1085,
	"./menu/tournaments.svg": 8346,
	"./my_favs.svg": 2717,
	"./success.svg": 2831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;